<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="5">
          <rsk-factor-form @emitRiskFactorData="createRiskFactor" />
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
            <rsk-factor-list :riskFactors="riskFactors" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RskFactorForm from "@/components/risk-factor/RskFactorForm";
import RskFactorList from "@/components/risk-factor/RskFactorList";

import { mapState } from "vuex";

export default {
  components: {
    RskFactorForm,
    RskFactorList,
  },
  computed: {
    ...mapState("RiskFactor", ["riskFactors"]),
  },
  methods: {
    createRiskFactor(data) {
      this.$store.dispatch("RiskFactor/createRiskFactor", data);
    },
  },
  created() {
    this.$store.dispatch("RiskFactor/getRiskFactors");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
